"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ConditionalLink = /** @class */ (function (_super) {
    __extends(ConditionalLink, _super);
    function ConditionalLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickLink = function (ev) {
            var _a = _this.props, onClick = _a.onClick, link = _a.link;
            if (!onClick) {
                return;
            }
            onClick(link, ev);
        };
        return _this;
    }
    ConditionalLink.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, link = _a.link, isNotClickable = _a.isNotClickable;
        var hasLink = link && link.url && link.url.length;
        var target = (link && link.newWindow) ? "_blank" : null;
        var rel = target === "_blank" ? "noopener" : null;
        if (!hasLink || isNotClickable) {
            return (React.createElement("a", { className: className }, children));
        }
        else {
            return (React.createElement("a", { href: link.url, target: target, rel: rel, className: "".concat(className, " ").concat(isNotClickable ? "" : "clickable", " "), onClick: this.clickLink }, children));
        }
    };
    return ConditionalLink;
}(React.Component));
exports.default = ConditionalLink;
